module.exports = {
  type: 'hex-chart',
  group: 'button',
  name: '图表',
  isForm: true,
  props: {
    listdata: {
      name: '图表数据',
      type: 'param-group',
      default: [{"name":"毛霞","val":'1'},{"name":"谢磊","val":'2'},{"name":"锺勇","val":'3'},{"name":"毛霞","val":'3'},],
      allowed: true
    },
    mockData: {
      name: '随机数据',
      type: 'hidden',
      default: '',
      allowed: true
    },
    name: {
      name: '名称字段',
      default: 'name'
    },
    value: {
      name: '数值字段',
      default: 'val'
    },
    sort_rule: {
      name: '排序',
      default: 'default',
      type: 'enum',
      values: [{
        value: 'default',
        text: '默认'
      },{
        value: 'up',
        text: '升序'
      },{
        value: 'down',
        text: '降序'
      }]
    },
    value_rule: {
      name: '数值规则',
      default: 'none',
      type: 'enum',
      values: [{
        value: 'none',
        text: '无'
      },{
        value: 'count',
        text: '计数'
      },{
        value: 'sum',
        text: '求和'
      },{
        value: 'average',
        text: '平均值'
      }]
    },
    color: {
      name: '条颜色',
      default: '#61E8B5'
    },
    max: {
      name: '最大值(0按照数据的最大计算)',
      default: '0'
    }
  },
  style: {
    "padding-top":"16px",
    "padding-bottom":"16px",
    "padding-left":"16px",
    "padding-right":"16px"
  },
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/chart/src/define.js